module.exports = __webpack_public_path__ + "media/雨夜 (电影《我要我们在一起》配乐).a925606f.mp3";